module.exports = __webpack_public_path__ + "static/img/Porte-de-la-Chapelle-Arena.b83c959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Porte-de-la-Chapelle-Arena.jpg
// module id = 64CV
// module chunks = 0